'use strict';
/* eslint-disable camelcase */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes$CLICK_NO;

var _underscore = require('underscore');

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _MessagesEventSchema = require('conversations-core/hublytics/MessagesEventSchema');

var _MessagesEventSchema2 = _interopRequireDefault(_MessagesEventSchema);

var _createLogAction = require('event-tracking-tools/redux/createLogAction');

var _createLogAction2 = _interopRequireDefault(_createLogAction);

var _urls = require('conversations-lib/urls');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _userSelectors = require('conversations-core/selectors/userSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEBOUNCE_WAIT = 500; // ms

exports.default = (_ActionTypes$CLICK_NO = {}, _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CLICK_NOTIFICATION_PERMISSION_HELP_LINK, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('clickPermissionHelpLink'), {
    user_id: state.auth.user.get('user_id'),
    parentName: action.payload
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SELECT_PERMISSION_VALUE, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('selectPermissionValue'), {
    user_id: state.auth.user.get('user_id'),
    permissionType: action.payload
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CLICK_BANNER_ACTION, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('clickBannerAction'), {
    user_id: state.auth.user.get('user_id'),
    permissionType: action.payload
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.LEFT_ONBOARDING, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('leftOnboarding'), {
    user_id: (0, _userSelectors.getUserId)(state),
    reason: action.payload
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.DISMISS_PROFILE_TIP, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('dismissProfileTip'), {
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('widgetLoaded'), {
    online: (0, _widgetDataSelectors.isResponderOnline)(state),
    page_url: state.widgetUi.url
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CLICK_PROFILE_TIP, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('clickProfileTip'), {
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, '@@router/LOCATION_CHANGE', function routerLOCATION_CHANGE(action, state, dispatch) {
  var pathname = action.payload.pathname;

  var screen = pathname.indexOf('widget') > -1 ? 'widget' : 'admin';

  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('pageView'), {
    where_screen: screen,
    where_subscreen: (0, _urls.getSubscreen)(pathname)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CREATED_CONTACT_FOR_CHANNEL, function (action, state, dispatch) {
  var isNewContact = action.payload.isNewContact;


  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('createContactForChannel'), {
    new_contact: isNewContact,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SELECT_EMBED_CODE_OPTION, function (action, state, dispatch) {
  var selectedOption = action.payload;

  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('selectEmbedCodeOption'), {
    method: selectedOption,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.UPDATE_PORTAL_SETTINGS_SUCCEEDED, function (action, state, dispatch) {
  var launcherType = action.payload.launcherType;


  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('launcherSave'), {
    type: launcherType,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CREATE_MESSAGE_SUCCEEDED, function (action, state, dispatch) {
  var newMessage = action.payload.response;
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('createMessage'), {
    message_id: newMessage.id,
    'user id': newMessage.creatorId
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.UPDATE_MESSAGE_SUCCEEDED, function (action, state, dispatch) {
  var messageData = action.payload.messageData;
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('createMessage'), {
    message_id: messageData.id,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SET_MESSAGE_PROPERTY, (0, _underscore.debounce)(function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('setMessageProperty'), {
    property_name: action.payload.key,
    user_id: (0, _userSelectors.getUserId)(state),
    property_value: action.payload.value
  }));
}, DEBOUNCE_WAIT)), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SET_MESSAGE_TARGET_AUDIENCE, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('setMessageTarget'), {
    target_audience_type: action.payload.targetAudienceType,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.TOGGLE_MESSAGE_STATUS, function (action, state, dispatch) {
  var id = '' + action.payload.id;
  var active = state.entities.getIn(['messages', id, 'active']);
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('toggleMessageStatus'), {
    message_id: id,
    new_status: active,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SET_PORTAL_SETTING, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('setPortalSetting'), {
    setting_name: action.payload.key,
    setting_value: String(action.payload.value),
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.TOGGLE_NOTIFICATION, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('setNotification'), {
    notification_type: action.payload.notificationType,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SET_USER_SETTING, (0, _underscore.debounce)(function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('setUserSetting'), {
    setting_name: action.payload.key,
    setting_value: action.payload.value,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}, DEBOUNCE_WAIT)), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SEND_EMBED_CODE_EMAIL_SUCCEEDED, function (action, state, dispatch) {
  var messageId = null;
  if (state.editMessage) {
    messageId = state.editMessage.id;
  }
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('sendEmbedCode'), {
    message_id: messageId,
    user_id: (0, _userSelectors.getUserId)(state)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CLICKED_MEETINGS_LINK, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('clickMeetingsLink'), {
    link_url: state.widgetData.meetingsLinkUrl,
    user_id: (0, _widgetDataSelectors.getResponderUserId)(state),
    page_url: state.widgetUi.url
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CLICK_VIRAL_LINK, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('clickViralLink'), {
    page_url: state.widgetUi.url
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.CLICKED_FOR_USER_DESCRIPTION, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('clickUserDescription'), {
    user_id: (0, _widgetDataSelectors.getResponderUserId)(state),
    page_url: state.widgetUi.url
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SEND_EMAIL_CAPTURE_EMAIL_SUCCEEDED, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('submitOfflineEmail'), {
    user_id: (0, _userSelectors.getUserId)(state),
    page_url: state.widgetUi.url
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SET_REP_STATUS_SUCCEEDED, function (action, state, dispatch) {
  var pathname = state.routing.locationBeforeTransitions.pathname;


  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('setRepStatus'), {
    new_status: action.payload,
    where_subscreen: (0, _urls.getSubscreen)(pathname)
  }));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('sendVisitorEmailAddress')));
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.ENQUEUE_OUTGOING_MESSAGE, function (action, state, dispatch) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      message = _action$payload.message;


  if (!(0, _ConversationalMessageModel.isConversationalMessage)(message)) {
    return;
  }

  var history = (0, _pipe2.default)(_conversationSelectors.getConversations, function (conversations) {
    return conversations.get(channel);
  }, _ConversationModel.getMessagesInHistory)(state);

  var firstMessageSent = history.size === 2;
  var continuedMessageSending = history.size > 2;

  if (firstMessageSent) {
    dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('sendInitialMessage'), {
      online: (0, _ConversationalMessageModel.isChatMessage)(message)
    }));
  } else if (continuedMessageSending) {
    dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('sendMessage'), {
      online: (0, _ConversationalMessageModel.isChatMessage)(message)
    }));
  }
}), _defineProperty(_ActionTypes$CLICK_NO, _ActionTypes2.default.TOGGLE_OPEN, function (action, state, dispatch) {
  dispatch((0, _createLogAction2.default)(_MessagesEventSchema2.default.get('toggleWidget'), {
    is_open: action.payload.isOpened,
    page_url: state.widgetUi.url
  }));
}), _ActionTypes$CLICK_NO);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/hublytics/hublyticsHandlers.js
// module id = 481
// module chunks = 0